import * as React from 'react';
import { Create, TextInput, required, SimpleForm, minValue } from 'react-admin';
import FileUpload from '../../common/inputs/FileUpload';

const BlogTopicCreate = () => (
    <Create redirect={'/ce_blog_topics'}>
        <SimpleForm>
            <FileUpload type="VIDEO_THUMBNAIL" source={'image'} required={true} />
            <TextInput source="name" fullWidth validate={[required()]} />
            <TextInput
                type={'number'}
                source="display_order"
                fullWidth
                validate={[required(), minValue(0)]}
            />
        </SimpleForm>
    </Create>
);

export default BlogTopicCreate;
